import { render, staticRenderFns } from "./RekategorisasiAset.vue?vue&type=template&id=eaf1fce0"
import script from "./RekategorisasiAset.vue?vue&type=script&lang=js"
export * from "./RekategorisasiAset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports